export default "__VITE_ASSET__CVl4uWU8__"